import { IDEA_STATUSES, IDEA_STATUS_LABELS } from '@cult/domain';
import type { IdeaStatus } from '@cult/schemas';
import { Tag } from 'antd';

const STATUS_COLOR: Record<IdeaStatus, string> = {
  [IDEA_STATUSES.KIV]: 'blue',
  [IDEA_STATUSES.ACCEPTED]: 'success',
  [IDEA_STATUSES.CLOSED]: 'error',
};

type Props = {
  status: IdeaStatus;
};

export const IdeaStatusTag = ({ status }: Props) => {
  return (
    <Tag color={STATUS_COLOR[status]} style={{ marginRight: 0, padding: '2px 10px' }}>
      {IDEA_STATUS_LABELS[status]}
    </Tag>
  );
};
